import { render, staticRenderFns } from "./Panduan.vue?vue&type=template&id=d6aeaece"
import script from "./Panduan.vue?vue&type=script&lang=js"
export * from "./Panduan.vue?vue&type=script&lang=js"
import style0 from "./Panduan.vue?vue&type=style&index=0&id=d6aeaece&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports